import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchWithToken } from "../auth/authorization";

export default function ImportPoints() {
    const apiBase = process.env.REACT_APP_SERVER_API_URL || "";
    const base = apiBase.replace(/\/$/, "");
    const navigate = useNavigate();
    const fetchWithToken = useFetchWithToken();

    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    function onFileChange(e) {
        setResult(null);
        setError(null);
        const f = e.target.files && e.target.files[0];
        setFile(f || null);
    }

    async function handleUpload(e) {
        e.preventDefault();
        setResult(null);
        setError(null);

        if (!file) {
            setError("Please choose an Excel (.xlsx/.xls) file to upload.");
            return;
        }

        const allowed = [".xlsx", ".xls"];
        const ext = (file.name || "").slice(((file.name || "").lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
        if (!allowed.some(a => a.replace(".", "") === ext)) {
            setError("File must be .xlsx or .xls");
            return;
        }

        const form = new FormData();
        form.append("file", file);

        setUploading(true);
        try {
            const res = await fetchWithToken(`${base}/api/import/upload`, {
                method: "POST",
                body: form
            });

            const data = await res.json().catch(() => null);
            if (!res.ok) {
                const msg = (data && (data.message || data.Message)) || `HTTP ${res.status}`;
                throw new Error(msg);
            }

            setResult(data);
        } catch (err) {
            console.error("Upload failed:", err);
            setError(err instanceof Error ? err.message : String(err));
        } finally {
            setUploading(false);
        }
    }

    return (
        <main className="container py-4" style={{ maxWidth: 800 }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Import Points</h3>
                <div>
                    <button className="btn btn-sm btn-secondary" onClick={() => navigate("/manage")}>Back</button>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleUpload}>
                        <div className="mb-3">
                            <label className="form-label">File</label>
                            <input
                                type="file"
                                className="form-control"
                                accept=".csv,.txt,.xlsx,.xls"
                                onChange={onFileChange}
                            />
                            <div className="form-text">Upload an Excel (.xlsx/.xls) file. Required columns: Name, CivicAddress, Lat, Lng</div>
                        </div>

                        {error && <div className="alert alert-danger">{error}</div>}

                        <div className="mb-3">
                            <button className="btn btn-primary" type="submit" disabled={uploading}>
                                {uploading ? "Uploading�" : "Upload"}
                            </button>
                        </div>
                    </form>

                    {result && (
                        <div className="mt-3">
                            <h5>Import result</h5>
                            <ul className="list-unstyled">
                                <li><strong>Created:</strong> {result.created ?? 0}</li>
                                <li><strong>Skipped:</strong> {result.skipped ?? 0}</li>
                            </ul>
                            {Array.isArray(result.errors) && result.errors.length > 0 && (
                                <div className="mt-2">
                                    <h6>Errors</h6>
                                    <ul>
                                        {result.errors.map((er, idx) => <li key={idx}>{er}</li>)}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </main>
    );
}